import axios from 'axios'

export function findPeopleInput(data) {
    return axios({
        method: 'get',
        url: '/user/smartEnterSchoolApply/user',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function findPeopleInputWxb(data) {
    return axios({
        method: 'get',
        url: '/user/smartEnterSchoolApply/userWxb',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function findUserByIden(data) {
    return axios({
        method: 'get',
        url:'/user/smartUser/findFK',
        params: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}

export function peopleInputById(data) {
    return axios({
        method: 'get',
        url: '/user/peopleInput/peopleInputById?id=' + data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function addPeopleInput(data) {
    return axios({
        method: 'post',
        url: '/user/smartEnterSchoolApply/people',
        data: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function batchAddPeopleInput(data) {
    return axios({
        method: 'post',
        url: '/user/smartEnterSchoolApply/people/batch',
        data: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function findSysUserByName(data) {
    return axios({
        method: 'get',
        url: '/user/SysUserWsg',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function findImg(id) {
    return axios({
        method: 'get',
        url: '/user/smartEnterSchoolApply/img',
        params: {id: id},
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function deletePeopleApply(id) {
    return axios({
        method: 'delete',
        url: '/user/smartEnterSchoolApply/people',
        params: {id: id},
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    });
}

export function findJkImg(id) {
    return axios({
        method: 'get',
        url: '/user/smartEnterSchoolApply/jkimg',
        params: {id: id},
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function findXcImg(id) {
    return axios({
        method: 'get',
        url: '/user/smartEnterSchoolApply/xcimg',
        params: {id: id},
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function findHsImg(id) {
    return axios({
        method: 'get',
        url: '/user/smartEnterSchoolApply/hsimg',
        params: {id: id},
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function getButtonFunc(buttonName) {
    return axios({
        method: 'get',
        url: '/user/SysFunction/button/' + buttonName,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}
